/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Degraded_Repair_LinkInputs */



/**
* | output |
* | --- |
* | "Fix live updates" |
*
* @param {Sync_Degraded_Repair_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_degraded_repair_link = /** @type {((inputs?: Sync_Degraded_Repair_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Degraded_Repair_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Live-Sync reparieren")
	return /** @type {LocalizedString} */ ("Fix live updates")
});